import React from "react";
import { Container } from "react-bootstrap";
import { useMatches } from "react-router";

import Breadcrumbs from "./BreadCrumbs";

import { IMatches } from "../types/shared";

const PageHeader = (): React.JSX.Element => {
    const matches: IMatches[] = useMatches() as IMatches[];
    let headerContent: string | undefined;

    for (let i = matches.length - 1; i >= 0; i--) {
        const match = matches[i];

        if (!match.handle?.noHeader) {
            if (match.handle?.header) {
                headerContent = match.handle.header(match.data);
                break;
            }
        } else {
            break;
        }
    }

    return headerContent ? (
        <div id="pageHeaderWrapper" data-testid="pageHeader">
            <Container>
                <h1>{headerContent && headerContent.toUpperCase()}</h1>
                <Breadcrumbs />
            </Container>
        </div>
    ) : (
        <></>
    );
};

export default PageHeader;
